import {
    List,
    DayBook,
    MyBillDetails,
    MonthlyBill,
    MonthlySummaryBill,
    ChitBill,
    Stock,
    TransactionDetails,
    MonthlySalePurchase,
    ItemRevenue,
    ProductionCost,
    ProductionCostDetails,
    LedgerDetails,
    GroupLedger,
    Groups,
    OfficerBill,
    MonthlyLedger,
    AuditLedgerDetails,
    PrepareBill,
    RejectedChitBill,
    PreSanctionDetails,
} from "../Components";

export default [
    {
        path: "/report/fd/today-member",
        component: List,
        name: "report-fd-today-members",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/day-book",
        component: DayBook,
        name: "report.fd.daybook",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/day-book-bill",
        component: () => import("@/App/FD/Reports/Components/DayBookBill.vue"),
        name: "report.fd.daybook.bill",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/day-book-removed",
        component: DayBook,
        name: "report.fd.daybook.removed",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/chit-bill",
        component: ChitBill,
        name: "report.fd.chit.bill",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/rejected-chit-bill",
        component: RejectedChitBill,
        name: "report.fd.rejected.chit.bill",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/daily-messing",
        component: DayBook,
        name: "voucher.fd.messing.daily",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/my-monthly-bill",
        component: MyBillDetails,
        name: "report.fd.my.bill",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/fd/monthly-bill",
        component: MonthlyBill,
        name: "report.fd.monthly.bill",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/payment/fd/monthly-bill/payment",
        component: () => import("@/App/FD/Reports/Components/PaymentMonthlyBill.vue"),
        name: "payment.fd.monthly.bill",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/fd/monthly-view-bill",
        component: () => import("@/App/FD/Reports/Components/MonthlyViewBill.vue"),
        name: "report.fd.monthly.view.bill",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/fd/payment-monthly-bill",
        component: () => import("@/App/FD/Reports/Components/PaymentMonthlyBill.vue"),
        name: "report.fd.payment.monthly.bill",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/fd/monthly-summary-bill",
        component: MonthlySummaryBill,
        name: "report.fd.monthly.summary.bill",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/fd/officer-bill",
        component: OfficerBill,
        name: "report.fd.officer.bill",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/fd/officer-weekly-bill",
        component: () => import("@/App/FD/Reports/Components/OfficerWeeklyBill.vue"),
        name: "report.fd.officer.weekly.bill",
        meta: {
            requiresAuth: true,
        },
    },

    // {
    //     path: "/report/fd/bill-prepare",
    //     component: PrepareBill,
    //     name: "report.fd.prepare.bill",
    //     meta: {
    //         requiresAuth: true,
    //     },
    // },

    {
        path: "/report/fd/stock",
        component: Stock,
        name: "report.fd.inventory.stock",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/item-voucher-details",
        component: TransactionDetails,
        name: "report.fd.product.transaction.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/monthly-sales-purchase-profit",
        component: MonthlySalePurchase,
        name: "report.fd.sales.purchase",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/monthly/sale-purchase",
        component: ItemRevenue,
        name: "report.fd.item.revinue.monthly",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/fd/production-cost",
        component: ProductionCost,
        name: "report.fd.production",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/production-cost/:id",
        component: ProductionCostDetails,
        name: "report.fd.production.details",
        meta: {
            requiresAuth: true,
        },
    },

    // { path: '/report/fd/item-voucher-details', component: ItemsVoucherDetails, name: 'report.fd.product.voucher.details' ,

    {
        path: "/report/fd/ledger",
        component: LedgerDetails,
        name: "report.fd.LedgerDetails",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/ledger/:id",
        component: GroupLedger,
        name: "report.fd.ledger",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/monthly-ledger/:id",
        component: MonthlyLedger,
        name: "report.fd.monthly.ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/fd/monthly-fund-pay/:cost_center_id",
        component: () => import("@/App/FD/Reports/Components/MonthlyFundPay.vue"),
        name: "report.fd.monthly.fund.pay",
        meta: {
            requiresAuth: true,
        },
    },

    // { path: '/report/fd/ledger-items', component: LedgerItemsDetails, name: 'report.fd.LedgerItemDetails' ,

    // {
    //     path: '/report/fd/ledger-details',
    //     component: LedgerTransactionDetails,
    //     name: 'report.fd.LedgerTranDetails'
    // ,

    //Account Group
    {
        path: "/report/fd/group",
        component: Groups,
        name: "report.fd.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/fd/group/:id",
        component: GroupLedger,
        name: "report.fd.group.ledger",
        meta: {
            requiresAuth: true,
        },
    },
    // { path: '/report/fd/group-emi', component: LedgerEMIDetails, name: 'report.fd.group.ledger.emi' ,

    {
        path: "/reports/fd/audit-ledger",
        component: AuditLedgerDetails,
        name: "report.fd.audit-ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/pre-sanction/details/:id",
        component: PreSanctionDetails,
        name: "report.fd.presanction.details",
        meta: {
            requiresAuth: true,
        },
    },
];
